import {
	theme,
	styledSystem as ss,
} from ".";

export interface ITextProps extends ss.ICommonProps, ss.ITypographyProps, ss.IFontSizeProps {
}

export const Text = ss.styled.span<ITextProps>`
	${ss.COMMON}
	${ss.FONTSIZE}
	${ss.TYPOGRAPHY}
`;
Text.defaultProps = {
	theme,
	m: 0,
	p: 0,
};
